<template>
  <div class="highseas-container">
    <div class="highseas-header" @click="$router.back()">
      <van-icon name="arrow-left" size="14" style="margin-right: 10px;" />
      <span>客户卡片</span>
    </div>
    <div class="card b-g-w">
      <div class="title">{{customer.custName}}</div>
      <div style="display: flex;margin-bottom: 5px;">
        <div class="flex-1">
          <span class="key">手机：</span>
          <span class="value">{{'156164498'}}</span>
        </div>
        <div class="flex-1">
          <span class="key">地区：</span>
          <span class="value">{{customer.areaName}}</span>
        </div>
      </div>
      <div style="margin-bottom: 5px;">
        <span class="key">微信号：</span>
        <span class="value">{{ }}</span>
      </div>
      <div style="margin-bottom: 5px;">
        <span class="key">微信昵称：</span>
        <span class="value">{{ }}</span>
      </div>
      <div style="margin-bottom: 5px;">
        <span class="key">地址：</span>
        <span class="value">{{ customer.custAddress }}</span>
      </div>
      <div class="tag-wrapper">
        <van-tag style="margin-right: 10px;" plain type="primary" v-if="customer.fuSalesName ">{{ customer.fuSalesName }}</van-tag>
        <van-tag style="margin-right: 10px;" plain type="primary" v-if="customer.custLevelId ">{{customer.custLevelId}}</van-tag>
        <van-tag plain type="primary" v-if="customer.industryName">{{customer.industryName}}</van-tag>
      </div>
    </div>
    <div class="card b-g-w">
      <div style="display: flex;">
        <div style="display: flex;flex: 1">
          <van-icon style="margin: 5px 5px 5px 0;" name="coupon" color="#1989fa" />
          <div>
            <div style="margin-bottom: 5px;font-size: 14px;">合同</div>
            <div style="color: #ccc; font-size: 12px;">
              <span>数量：</span>
              <span style="color: #546B95;">1</span>
              <span>个</span>
            </div>
          </div>
        </div>
        <div style="display: flex;flex: 1">
          <van-icon style="margin: 5px 5px 5px 0;" name="coupon" color="#1989fa" />
          <div>
            <div style="margin-bottom: 5px;font-size: 14px;">合同</div>
            <div style="color: #ccc; font-size: 12px;">
              <span>订单：</span>
              <span style="color: #546B95;">1</span>
              <span>个</span>
            </div>
          </div>
        </div>
        <div style="display: flex;flex: 1">
          <van-icon style="margin: 5px 5px 5px 0;" name="coupon" color="#1989fa" />
          <div>
            <div style="margin-bottom: 5px;font-size: 14px;">合同</div>
            <div style="color: #ccc; font-size: 12px;">
              <span>联系人：</span>
              <span style="color: #546B95;">1</span>
              <span>个</span>
            </div>
          </div>
        </div>
        <div style="display: flex;flex: 1">
          <van-icon style="margin: 5px 5px 5px 0;" name="coupon" color="#1989fa" />
          <div>
            <div style="margin-bottom: 5px;font-size: 14px;">合同</div>
            <div style="color: #ccc; font-size: 12px;">
              <span>联系提示：</span>
              <span style="color: #546B95;">1</span>
              <span>个</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="concat-container">
      <div class="concat-header">
        <div class="title">
          联系记录({{listVisit.length}})
        </div>
        <van-icon name="plus" />
      </div>
      <div class="concat-list">
        <div class="concat-item" v-for="visit in listVisit" :key="visit.visitId">
          <div class="content-item">
            <div class="content-header m-b-20">{{visit.contactName}}
              <span style="color:#999999">{{visitTypeFormat(visit.visitType)}}</span>
              <span style="color:#999999" v-if="visit.contactName">【{{visit.contactName}}】</span>
            </div>
            <div class="content-main m-b-20"> {{visit.content}} </div>
            <div class="content-footer ">
              来自pc web {{visit.createTime}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { List, Cell, Button, Tag, Dialog, Area, Toast, Icon, Field, Col, Row, CellGroup, Popup, Picker, Radio, RadioGroup } from 'vant'
import { listCust, getInfo } from "@/api/scrm/custhighseas";
import { queryListVisit } from "@/api/scrm/custvisit";

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      customer: {},
      listVisit: [],
      custVisitTypeOptions: []
    }
  },
  mounted() {
    this.getDicts("crm_cust_visit_type").then(response => {
      this.custVisitTypeOptions = response.data;
    });
    this.queryCustomer()
    this.queryListVisit()

  },
  methods: {
    async queryCustomer() {
      const res = await getInfo(this.$route.params.id)
      if (res.code === 200) {
        this.customer = res.data
      }
    },
    //获取访问类型
    visitTypeFormat(visitType) {
      if (this.custVisitTypeOptions != null) {
        var visitName = this.selectDictLabel(this.custVisitTypeOptions, visitType);
        if (visitName != null && visitName != '') {
          return "【" + visitName + "】";
        }
      }
    },
    async queryListVisit() {
      const res = await queryListVisit({ custId: this.$route.params.id })
      console.log(res)
      if (res.code === 200) {
        this.listVisit = res.data
      }
    }
  }
}
</script>

<style lang="less" scoped>
.highseas-container {
  height: 100vh;
  background-color: #eee;
  font-size: 20px;
  .highseas-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 20px 10px 10px 30px;
  }
  .tag-wrapper {
    display: flex;
    justify-content: center;
  }
  .b-g-w {
    background-color: #fff;
  }
  .m-b-20 {
    margin-bottom: 20px;
  }

  .key {
    color: #ccc;
  }
  .value {
  }
  .concat-container {
    background-color: #fff;

    .concat-header {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .concat-list {
      .concat-item {
        border-bottom: 1px solid #eee;
        padding: 30px;
        .content-footer {
          font-size: 10px;
          color: #ccc;
        }
      }
    }
  }
}
</style>
